import ViewModel from './viewModel';

class HeaderViewModel extends ViewModel {
	constructor() {
        super();
	    this.viewStates = {
			showLoadingGif: false,
			showErrorModal: false
	    }
	    this.events = {

		}
	}
	run(functionName){
      return this[functionName](selector);
    }
}

let HeaderView = new HeaderViewModel();

export default HeaderView;
